// extracted by mini-css-extract-plugin
export var table = "_tt-0";